export default "__VITE_ASSET__B73aOxA9__"